import { Description } from '@monorepo/shared/componentsV2/Description';
import { Link } from '@monorepo/shared/componentsV2/Link';
import { useHasOrganizationUpdatePermissions } from '@monorepo/shared/hooks/permissions/useHasPermissions';
import { header4 } from '@monorepo/shared/styles/text';
import React from 'react';
import styled from 'styled-components';
import { useOrganizationDocumentFolderSetupLink } from '../../hooks/useSiteDocumentsLinks';

const TitleContainer = styled.div`
  padding: 1.5rem 1rem 1rem;
`;

const SectionTitle = styled.h2`
  ${header4}
  padding-bottom: 0.5rem;
  margin: 0;
`;

interface OrganizationScopedFolderIntroProps {
  organizationId: string;
  folderId: string;
}

export function OrganizationScopedFolderIntro({
  organizationId,
  folderId,
}: OrganizationScopedFolderIntroProps) {
  const canManageInSetup = useHasOrganizationUpdatePermissions(organizationId);
  const setupFolderLink = useOrganizationDocumentFolderSetupLink(folderId);

  return (
    <TitleContainer>
      <SectionTitle>All sites folder</SectionTitle>
      <Description>
        Documents in this folder are shared across all sites. They are managed
        in{' '}
        {canManageInSetup ? <Link to={setupFolderLink}>Setup</Link> : 'Setup'}.
      </Description>
    </TitleContainer>
  );
}
